var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1516 17.596L21.4269 19.8713C21.7434 20.1878 21.7434 20.701 21.4269 21.0176C19.7156 22.7289 17.0063 22.9214 15.0702 21.4693L13.9619 20.6381C12.2184 19.3304 10.6696 17.7816 9.3619 16.0381L8.53067 14.9298C7.07858 12.9937 7.27112 10.2844 8.98243 8.57313C9.29896 8.2566 9.81215 8.2566 10.1287 8.57313L12.404 10.8484C12.7945 11.239 12.7945 11.8721 12.404 12.2627L11.5749 13.0918C11.4306 13.236 11.3949 13.4564 11.4861 13.6389C12.5409 15.7485 14.2515 17.4591 16.3611 18.5139C16.5436 18.6051 16.764 18.5694 16.9082 18.4251L17.7373 17.596C18.1279 17.2055 18.761 17.2055 19.1516 17.596Z",
    stroke: "#632B51"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    stroke: "#EFBF7D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.b31e387511445aa5ef832d3c45b11fb8.svg";
export { ForwardRef as ReactComponent };